import { FieldValidationError } from '../../types/form/field-validation-error';
export function isEmailSuggestionFieldValidationResult(result) {
    if (result === undefined || typeof result === 'string') {
        return false;
    }
    return result.error === FieldValidationError.EmailSuggestion;
}
export const isValidFieldValidationResult = (result) => {
    if (result === undefined) {
        return true;
    }
    if (typeof result === 'string') {
        return false;
    }
    return result.error === FieldValidationError.EmailSuggestion; // Email suggestions are optional.
};
export const isStandardFieldValidationResult = (result) => {
    return result !== undefined && typeof result === 'object';
};
//# sourceMappingURL=field-validation-result.js.map